// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu[data-v-46b59eda]{position:fixed;display:flex;flex-direction:column;align-items:flex-start;visibility:hidden;background:#fff;border:1px solid #e7e6eb;border-radius:8px;overflow-y:hidden;overflow-x:hidden;transition:left .3s,top .3s,height .3s,width .3s;z-index:10001}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
